// extracted by mini-css-extract-plugin
export default {"main":"PageError_main__eZF5U","container":"PageError_container__C4Sab"};